// extracted by mini-css-extract-plugin
export default {"header":"header_header__MhatS","titleSection":"header_titleSection__xvQ4v","selectSection":"header_selectSection__PV-XB","back_button":"header_back_button__slpD5"};